export default "__VITE_PUBLIC_ASSET__39aefe2f__"